export default "__VITE_PUBLIC_ASSET__690af9d3__"